import { useAccount } from "@apis/accounts/useAccounts"
import { useGetWinbackQuery } from "@apis/winbacks/useWinbacks"
import type { TTitleValueItem } from "@components/TitleValueList/types"
import { formatDate, formatRate } from "@utils/formatters"

type TAccountDropInfoData = {
  status_group: string | undefined
  account_status_code: string | undefined
  items: TTitleValueItem[]
}

export const useAccountDropInfoSerializer = (account_id: string) => {
  const getWinback = useGetWinbackQuery(account_id)
  const getAccount = useAccount(account_id)

  const isError = getWinback.isError || getAccount.isError

  const data: TAccountDropInfoData = {
    status_group: getAccount.data?.status_group,
    account_status_code: getAccount.data?.account_status_code,
    items: [
      {
        title: { content: "Drop Reason:" },
        value: {
          content: getWinback.data?.drop_reason,
          isPending: getWinback.isPending,
        },
      },
      {
        title: { content: "Drop Requested:" },
        value: {
          content: formatDate(getWinback.data?.drop_dt),
          isPending: getWinback.isPending,
        },
      },
      {
        title: { content: "Confirmed Drop:" },
        value: {
          content: formatDate(getWinback.data?.confirmed_end_dt),
          isPending: getWinback.isPending,
        },
      },
      {
        title: { content: "Service Period:" },
        value: {
          content: (() => {
            const confirmedStartDt = formatDate(
              getWinback.data?.confirmed_start_dt,
            )
            const confirmedDropDt = formatDate(
              getWinback.data?.confirmed_drop_dt,
            )

            return confirmedStartDt
              ? confirmedDropDt
                ? `${confirmedStartDt} - ${confirmedDropDt}`
                : confirmedStartDt
              : ""
          })(),
          isPending: getWinback.isPending,
        },
      },
      {
        title: { content: "Upcoming Rate:" },
        value: {
          content: (() => {
            const upcomingRate = formatRate(
              getAccount.data?.upcoming_rate,
              getAccount.data?.unit_of_measure,
            )
            const upcomingRateSourceType =
              getAccount.data?.upcoming_rate_source_type

            return upcomingRate
              ? upcomingRateSourceType
                ? `${upcomingRate} - ${upcomingRateSourceType}`
                : upcomingRate
              : ""
          })(),
          isPending: getAccount.isPending,
        },
      },
    ],
  }

  return {
    data,
    isError,
  }
}
